import { Page } from '../components';
import { PullAndSendForm } from '../forms/PullAndSendForm';

export const PullAndSend = () => (
  <Page render={() => <PullAndSendForm />} />
);
